var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('h1',[_vm._v("Traitement")]),_c('treatment',{ref:"myTreatment"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }